import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../axios";
import "./ServiceDetails.css"; // Add styles for better presentation

const ServiceDetails = () => {
  const { slug } = useParams(); // Get slug from URL
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServiceDetails = async () => {
      try {
        const apiUrl = `${process.env.REACT_APP_API_URL}api/services/${slug}/`;
        const response = await axios.get(apiUrl);
        
        setService(response.data);
      } catch (error) {
        console.error("Error fetching service details:", error);
        setError("Service not found or an error occurred.");
      } finally {
        setLoading(false);
      }
    };
  
    fetchServiceDetails();
  }, [slug]);
  
  if (loading) return <p>Loading service details...</p>;
  if (error) return <p className="error">{error}</p>;

  return (
    <div className="service-details-container">
      {/* Title at the top */}
      
  
      {/* Two-column layout */}
      <div className="service-content">
        {/* Left: Image */}
        <div className="service-image-container">
          <img src={service.icon_image_url} alt={service.title} className="service-image" />
        </div>
  
        {/* Right: Description */}
        <div className="service-text">
          {/* Render HTML content */}
          <h1 className="service-title">{service.title}</h1>
          <div
            className="service-description"
            dangerouslySetInnerHTML={{ __html: service.detailed_description }}
          ></div>
        </div>
      </div>
    </div>
  );
  
};

export default ServiceDetails;
